import type { Project } from "../lib/projects";
import { AuroraForecasterRadial } from "./AuroraForecasterRadial";
import { MetroinfoNanoleaf } from "./MetroinfoNanoleaf";

interface ProjectCardProps {
  project: Project;
  onClick: () => void;
  index?: number;
  scrollProgress?: number;
}

export function ProjectCard({ project, onClick, index = 0, scrollProgress = 0 }: ProjectCardProps) {
  const isMetroinfo = project.id === "metroinfo-ha";
  const isAuroraForecaster = project.id === "aurora-forecaster";

  return (
    <article
      className="group cursor-pointer transition-transform duration-300 hover:-translate-y-1"
      onClick={onClick}
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="project-card relative flex flex-col overflow-hidden panel-card transition-shadow duration-300 ease-[var(--ease)]">
        <div className="aspect-square w-full overflow-hidden bg-panel">
          {isMetroinfo ? (
            <MetroinfoNanoleaf scrollProgress={scrollProgress} variant="card" />
          ) : isAuroraForecaster ? (
            <AuroraForecasterRadial scrollProgress={scrollProgress} variant="card" />
          ) : project.image ? (
            <img
              src={project.image}
              alt={project.title}
              className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-text-muted">
              <span className="font-mono text-4xl opacity-50">{project.title.charAt(0)}</span>
            </div>
          )}
        </div>
        <div className="p-8">
          <div className="text-base mb-4">{project.title}</div>
          <div className="text-[0.9rem] text-text-dim leading-relaxed line-clamp-2">{project.subtitle}</div>
        </div>
      </div>
    </article>
  );
}
